import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Modal, ResourceList, TextField, Page, Button, Thumbnail } from '@shopify/polaris';

const propTypes = {
  // items: PropTypes.object.isRequired,
  // onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onRequest: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};


const OrderSuplyRequestModal = (props) => {
  // console.log("OrderSuplyRequestModal", props);
  return (
      <div className="mt10">
        { props.items &&
        <table className="PolarisTableCopy">
          <thead>
            <tr>
              <th>
                { "" } 
              </th>
              <th>
                { I18n.t(`shopify.line_item.vendor`) }
              </th>
              <th>
                { I18n.t(`shopify.line_item.name`) }
              </th>
              <th>
                { I18n.t(`shopify.line_item.variant_title`) }
              </th>
              <th>
                { I18n.t(`shopify.line_item.sku`) }
              </th>
              <th>
                { I18n.t(`shopify.line_item.quantity`) }
              </th>
              <th>
                { I18n.t(`shopify.line_item.orders`) }
              </th>
            </tr>
          </thead>
          <tbody>
            { props.items.entrySeq().map( ([vendorKey, value]) => (
                <React.Fragment key={vendorKey}>
                  <tr>
                    <td className="vendorHeader" colSpan={7}>
                      <div className="flex justifyBetween alignItemsCenter">
                        <span>{vendorKey}</span>
                        <Button 
                          disabled={ value.requested || props.loading }
                          onClick={ () => props.onRequest(vendorKey) } >
                          { value.requested ? I18n.t("app.requested") : I18n.t("app.request") }
                        </Button>
                      </div>
                    </td>
                  </tr>
                  { value.lineItems.map( (li) => (
                    <tr key={li.id}>
                      <td className="text-center">
                        <Thumbnail
                          source={ li.imageSrc }
                        />
                      </td>
                      <td>{ li.vendor }</td>
                      <td>{ li.name }</td>
                      <td>{ li.variantTitle }</td>
                      <td>{ li.sku }</td>
                      <td>{ li.quantity }</td>
                      <td>{ li.orderNumber }</td>
                    </tr>
                  ))}
                </React.Fragment>
              ))  
            }
          </tbody>
        </table>
      }
    </div>
  );
}


OrderSuplyRequestModal.propTypes = propTypes;


export default OrderSuplyRequestModal;

{/* <Modal
      open={props.open}
      size="Full"
      large
      title="Scrollable content"
      onClose={props.onClose}
    >
      <Modal.Section> */}
{/* </Modal.Section> */ }
{/* </Modal> */ }